import styled from 'styled-components';
import { theme } from 'styled-tools';

import { Button, CalmTheme, fontWeight, FontWeights } from '@calm-web/design-system';

import { PlanTileProps } from './types';

const { palette } = CalmTheme;

export const Wrapper = styled.div<Pick<PlanTileProps, 'theme'>>`
	align-items: center;
	background: ${p => (p.theme === 'limited' ? palette.white : 'rgba(255, 255, 255, 0.83)')};
	border-radius: 16px;
	box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.15);
	display: flex;
	flex-direction: column;
	min-height: 300px;
	overflow: hidden;
	padding-bottom: 20px;
	position: relative;
	width: 100%;
`;

export const Banner = styled.div<Pick<PlanTileProps, 'theme'>>`
	background: ${p => (p.theme === 'limited' ? palette.gradientYellow : palette.gray2)};
	color: ${palette.gray7};
	font-size: 15px;
	${fontWeight(FontWeights.Medium)};
	padding: 12px 0;
	text-align: center;
	width: 100%;

	${p =>
		p.theme === 'limited'
			? `
        font-weight: 900;
        font-size: 18px;
      `
			: ''}
`;

export const Description = styled.div<{
	isReady: boolean;
}>`
	margin: 36px 0 27px 0;
	opacity: ${p => (p.isReady ? '1' : '0')};
	padding: 0 10px;
	transform: translate3d(0, ${p => (p.isReady ? '0' : '-10px')}, 0);
	transition: ${theme('animation.transition')};
	width: 100%;
`;

export const LoaderWrapper = styled.div`
	left: 50%;
	position: absolute;
	transform: translate3d(-50%, -50%, 0);
	top: 50%;
	width: 180px;
`;

export const PlanName = styled.h2`
	color: ${palette.black};
`;

export const Details = styled.p`
	color: ${palette.black};
	margin: 0 auto;
	width: 50%;
`;

export const PlanButton = styled(Button)`
	margin-top: auto;
	max-width: 200px;
	width: 100%;
`;
